import React from 'react'

const IsEmpty = ({icon, message}) => {
    return (
        <div className='text-center text-white fs-9s mx-auto d-flex flex-column justify-content-center align-items-center opacity-75' style={{minHeight:"10rem", background:'transparent'}}>
            <i className={`${icon} fs-1`}></i>
            <p className='fw-medium mb-0'>{message}</p>
        </div>
    )
}

export default IsEmpty